import type { TaskResult } from "../types";

export async function gradeProject1(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Calcular asistencia promedio con AVERAGE en C12
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Asistencia de Visitantes");
    const range = sheet.getRange("C12");
    range.load("formulas");
    await context.sync();

    const realFormula = range.formulas[0][0];
    const expectedFormula = "=AVERAGE(Asistencia[[Enero]:[Junio]])";
    results.push({ taskId: 1, passed: realFormula === expectedFormula });
  });

  // Tarea 2: Ampliar meses (Julio-Diciembre en H3:M3)
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Asistencia de Visitantes");
    const range = sheet.getRange("H3:M3");
    range.load("values");
    await context.sync();

    const mesesEsperados = ["Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const actualValues = range.values[0];
    const passed = mesesEsperados.every((m, i) => actualValues[i] === m);
    results.push({ taskId: 2, passed });
  });

  // Tarea 3: Fórmula condicional en F4:F8
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Actividades-Guardabosques");
    const rangoB = hoja.getRange("B4:B8");
    const rangoE = hoja.getRange("E4:E8");
    const rangoF = hoja.getRange("F4:F8");
    rangoB.load("values");
    rangoE.load("values");
    rangoF.load("values");
    await context.sync();

    let passed = true;
    for (let i = 0; i < 5; i++) {
      const valorB = rangoB.values[i][0];
      const valorE = rangoE.values[i][0];
      const valorF = rangoF.values[i][0];
      const esperado = valorB !== "Ninguno" && valorE === "Si" ? "Si" : "No";
      if (valorF !== esperado) { passed = false; break; }
    }
    results.push({ taskId: 3, passed });
  });

  // Tarea 4: Formato condicional >= 200,000
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Asistencia de Visitantes");
    const rango = hoja.getRange("B4:M8");
    const formatosCondicionales = rango.conditionalFormats;
    formatosCondicionales.load("items");
    await context.sync();

    let formatoEncontrado = false;
    for (const formato of formatosCondicionales.items) {
      if (formato.type === Excel.ConditionalFormatType.cellValue) {
        const regla = formato.cellValue;
        regla.load(["rule"]);
        await context.sync();
        if (regla.rule.operator === "GreaterThanOrEqual" && regla.rule.formula1 === "=200000") {
          formatoEncontrado = true;
          break;
        }
      }
    }
    results.push({ taskId: 4, passed: formatoEncontrado });
  });

  // Tarea 5: Tabla dinámica en formato Esquema
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Programas por Parque");
    const pivot = sheet.pivotTables.getItem("TablaDinamica2");
    pivot.load("layout/layoutType");
    await context.sync();
    results.push({ taskId: 5, passed: pivot.layout.layoutType === "Outline" });
  });

  return results;
}
